var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconComingSoonMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 59,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 4.96H29.32V4a4 4 0 00-4-4h-10.4a4 4 0 00-4 4v.96H4a4 4 0 00-4 4v45.2a4 4 0 004 4h72a4 4 0 004-4V8.96a4 4 0 00-4-4zm0 4v16H56.32a17.64 17.64 0 00-32.64 0H4v-16h72zM40 45.24c-7.555 0-13.68-6.125-13.68-13.68S32.445 17.88 40 17.88s13.68 6.125 13.68 13.68A13.68 13.68 0 0140 45.24zm19.28-28h11.04a2 2 0 002-2 2.04 2.04 0 00-2-2H59.28a2 2 0 00-2 2 2 2 0 002 2.08v-.08zM40 21.8c-5.368 0-9.72 4.352-9.72 9.72s4.352 9.72 9.72 9.72 9.72-4.352 9.72-9.72A9.72 9.72 0 0040 21.8z",
    fill: "#CFCFCF",
    fillRule: "nonzero"
  })));
}

export default SvgIconComingSoonMd;